import { render } from "./FurniMozPage.vue?vue&type=template&id=106b9fe7&scoped=true"
import script from "./FurniMozPage.vue?vue&type=script&lang=js"
export * from "./FurniMozPage.vue?vue&type=script&lang=js"

import "./FurniMozPage.vue?vue&type=style&index=0&id=106b9fe7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106b9fe7"]])

export default __exports__